"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectEIP712TypedData = void 0;
const isObjectEIP712TypedData = (obj) => {
    return typeof obj === 'object' && obj != null && 'domain' in obj && 'types' in obj && 'message' in obj;
};
exports.isObjectEIP712TypedData = isObjectEIP712TypedData;
//# sourceMappingURL=sdk.js.map